import { Injectable } from '@angular/core'
import { Observable } from 'rxjs/Observable'
import { HttpClient, HttpHeaders } from '@angular/common/http'
import { environment } from 'environments/environment'
import { UPTOPResponse } from 'app/models/uptop'
import {
  SharepointResponse,
  SharepointContent, SharepointData, SharepointFile
} from 'app/models/sharepoint-data'

@Injectable()
export class SharepointService {

  private sharepointUrl = environment.api.url + environment.api.sharepoint.url

  constructor(private http: HttpClient) {
  }

  deleteFile(id: string): Observable<UPTOPResponse> {
    return this.http
      .delete<UPTOPResponse>(this.sharepointUrl, {params: {id: id}})
  }

  downloadSharepoint(id: string): Observable<SharepointContent> {
    return this.http
      .get(this.sharepointUrl, {params: {id: id}})
      .switchMap((result: SharepointResponse) => this.downSharepointFile(result.sharepoint))
  }

  uploadSharepoint(data: SharepointFile, content: Blob): Observable<UPTOPResponse> {
    data.name = `${data.displayName}`.toLowerCase()
    return this.http
      .post<SharepointResponse>(this.sharepointUrl, data)
      .switchMap((result: SharepointResponse) =>
        this.upSharepointFile(result.sharepoint, content))
  }

  downSharepointFile(data: SharepointData): Observable<SharepointContent> {
    return this.http
      .get(data.fileUrl, {
        responseType: 'blob',
        headers: new HttpHeaders({
          'Authorization': 'Bearer ' + data.accessToken,
          'Content-Type': data.mimeType,
        })
      }).map((result) =>
        new SharepointContent(new Blob([result], {type: data.mimeType}), data.fileName)
      )
  }

  upSharepointFile(data: SharepointData, content: Blob): Observable<UPTOPResponse> {
    return this.http
      .post<UPTOPResponse>(data.fileUrl, content, {
        headers: new HttpHeaders({
          'Authorization': 'Bearer ' + data.accessToken,
          'Content-Type': data.mimeType,
        })
      }).catch((err) => {
        console.log('Error uploading file to sharepoint', err)
        // Remove from database if sharepoint upload is failed
        this.deleteFile(data.fileId).subscribe()
        return Observable.throw(err || 'ServerErr')
      })
  }

}



// WEBPACK FOOTER //
// ./src/app/services/sharepoint.service.ts